import platform from 'platform'

const SUPPORTED_BROWSERS: { [key: string]: number } = {
  CHROME: 83
}

declare const navigator

function getBrowserInfo () {
  return (function () {
    const ua = navigator.userAgent
    let tem,
      // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || []
      return 'IE ' + (tem[1] || '')
    }
    if (M[1] === 'Chrome') {
      // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
      tem = ua.match(/\b(OPR|Edg|Edge)\/(\d+)/)
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
    return { name: M[0], version: M[1] }
  })()
}

export function getSupportedBrowserVersion (): { isSupported: boolean; browser: string; version: number} {
  const browserName = platform.name.toUpperCase()
  const browserVersion = parseFloat(platform.version)
  const info = {
    isSupported: false,
    browser: browserName,
    version: browserVersion
  }

  if (SUPPORTED_BROWSERS[browserName]) info.isSupported = browserVersion >= SUPPORTED_BROWSERS[browserName]
  return info
}
